import React from "react";
import api from "../lib/api";
import { toast } from "sonner";

const LISTS = [["ambar", "AMBAR LİSTESİ"], ["nakliyeci", "NAKLİYECİLER"]];

export const MoveMenu = ({ from, id, name, onMoved }) => (
  <select
    data-testid={`move-${from}-${id}`}
    value=""
    title="BAŞKA LİSTEYE AKTAR"
    onChange={async (e) => {
      const to = e.target.value; if (!to) return;
      const label = LISTS.find((l) => l[0] === to)[1];
      if (!window.confirm(`${name || "KAYIT"} → ${label} LİSTESİNE AKTARILSIN MI? (BU LİSTEDEN ÇIKAR)`)) return;
      await api.post("/move", { data: { from, to, id } });
      toast.success(`${label} LİSTESİNE AKTARILDI`);
      onMoved();
    }}
    className="h-7 rounded border border-violet-600 bg-violet-600 px-1 text-[10px] font-bold text-white"
  >
    <option value="">AKTAR ▸</option>
    {LISTS.filter((l) => l[0] !== from).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
  </select>
);
